// The signature. Every order in this product is one fact — something moves from
// A to B — and this is that fact drawn. A filled node for the pickup, a ring for
// the drop-off, a rule between them.
//
// It appears in exactly three places, and nowhere it is not true: the order row,
// the top of order detail (as JourneyRail, which adds progress), and step one of
// the form, where it fills in live as the two locations are chosen.

const SIZES = {
  // Order rows: tight, sits under the order number without crowding it.
  sm: {
    grid: 'grid-cols-[12px_1fr] gap-x-2.5',
    pad: 'py-[5px]',
    node: 'w-[7px] h-[7px]',
    ring: 'border-[1.5px]',
    rail: 'w-px min-h-[14px] bg-hairline',
    gap: 'gap-1.5',
  },
  // The form preview: bigger, because here it is the thing being built.
  md: {
    grid: 'grid-cols-[14px_1fr] gap-x-3',
    pad: 'py-1.5',
    node: 'w-[9px] h-[9px]',
    ring: 'border-2',
    rail: 'w-0.5 min-h-[26px] bg-gradient-to-b from-brand to-hairline',
    gap: 'gap-[18px]',
  },
}

export default function RouteLine({ size = 'sm', pickup, dropoff, className = '' }) {
  const s = SIZES[size]

  return (
    <div className={`grid items-stretch ${s.grid} ${className}`}>
      {/* Decorative: the labelled content beside it already says pickup and
          drop-off, so the nodes would only be read out as two empty shapes. */}
      <div aria-hidden="true" className={`flex flex-col items-center ${s.pad}`}>
        <span className={`flex-none rounded-full bg-brand ${s.node}`} />
        <span className={`flex-1 ${s.rail}`} />
        <span className={`flex-none rounded-full border-brand ${s.node} ${s.ring}`} />
      </div>

      <div className={`flex flex-col min-w-0 ${s.gap}`}>
        <div className="min-w-0">{pickup}</div>
        <div className="min-w-0">{dropoff}</div>
      </div>
    </div>
  )
}
